<div class="mt-5"></div>

<div class="row">
  <div class="col-xl-3 col-lg-2 col-md-1 col-sm-0"></div>
  <div class="col-xl-6 col-lg-8 col-md-10 col-sm-12">
    <app-panel [showHeader]="true">
      <div panel-header>

        <div>
          <div style="float:left" (click)="toggleParentsApp()">
            <span *ngIf="!isParentsApp()">Web Portal</span>
            <span *ngIf="isParentsApp()===true">{{'PARENTS.APP'|translate}}</span>
          </div>
          <div style="float:right">
            <button type="button" class="scg-unstyled-button pr-1" (click)="language = Language.English"><img src="./assets/images/lang-en.png"></button>
            <button type="button" class="scg-unstyled-button pr-1" (click)="language = Language.French"><img src="./assets/images/lang-fr.png"></button>
            <button type="button" class="scg-unstyled-button" (click)="language = Language.German"><img src="./assets/images/lang-de.png"></button>
          </div>
        </div>

      </div>
      <div panel-content>

        <div class="d-none d-sm-block" style="height:15px"></div>

        <div>
          <form (ngSubmit)="onLogin()" #loginForm="ngForm">
            <div class="form-group row">
              <!-- <div class="col-sm-4">
                <label for="username">{{'LOGIN.USERNAME' | translate}}</label>
              </div> -->
              <label for="username" class="col-sm-4 col-form-label">{{'LOGIN.USERNAME' | translate}}</label>
              <div class="col-sm-6">
                <input [(ngModel)]="credentials.username" #name="ngModel" name="username" id="username" type="email" class="form-control" required>
              </div>
            </div>

            <div class="form-group row">
              <!-- <div class="col-sm-4">
                <label for="password">{{'LOGIN.PASSWORD' | translate}}</label>
              </div> -->
              <label for="password" class="col-sm-4 col-form-label">{{'LOGIN.PASSWORD' | translate}}</label>
              <div class="col-sm-6">
                <input [(ngModel)]="credentials.password" #password="ngModel" name="password" id="password" type="password" class="form-control" required>
              </div>
            </div>


            <div *ngIf="isLoginV2===true || isParentsLogin===true || isParentsApp()" class="row">
              <div class="offset-sm-4 col-12">
              <app-checkbox [(checked)]="savePassword" [caption]="'LOGIN.SAVE_PASSWORD' | translate"></app-checkbox>
              </div>
            </div>


            <div class="row">
              <div class="col-12 col-sm-12">
                <div class="scg-note-error" *ngIf="loginError === LoginError.IncorrectCredentials">{{'LOGIN.ERROR_PASSWORD'|translate}}</div>
                <div class="scg-note-error" *ngIf="loginError === LoginError.OtherError">{{'LOGIN.ERROR_OTHER'|translate}}</div>
                <div class="scg-note-error" *ngIf="loginError === LoginError.Forbidden">{{'LOGIN.ERROR_FORBIDDEN'|translate}}</div>
              </div>
            </div>

            <div class="mt-3"></div>

            <div class="container-fluid">
              <div class="row d-flex justify-content-between">
                  <a [routerLink]="['/recover-password']" class="d-none d-sm-block btn btn-outline-primary">{{'LOGIN.FORGOT'|translate}}?</a>
                  <button type="submit" *appBtnLoading="isLoadingLogin" class="btn btn-primary text-uppercase col-12 col-sm-4">{{'LOGIN.LOGIN' | translate}}</button>
              </div>
            </div>

            <div class="row d-none d-sm-block">
              <div class="col-12" style="text-align: center">
                <hr>
                <button type="button" (click)="onCreateAccountClick()" class="scg-link-native">{{'LOGIN.CREATE'|translate}}</button>
              </div>
            </div>

            <div class="row d-block d-sm-none" style="text-align:center">
              <hr style="margin-top:50px">
              <a [routerLink]="['/recover-password']" class="scg-link-native">{{'LOGIN.FORGOT'|translate}}?</a>
              <div class="mt-2"></div>
              <button type="button" (click)="onCreateAccountClick()" class="scg-link-native">{{'LOGIN.CREATE'|translate}}</button>
            </div>

            <div *ngIf="showCreateNotice===true" class="text-center mt-2">
              <div [innerHtml]="'LOGIN.CREATE_ACCOUNT' | translate"></div>
            </div>
          </form>
        </div>
      </div>
    </app-panel>

  </div>
</div>

<!-- isIos={{isIos}}|alone={{isIosAlone}} -->
<!-- IOS PWA detection -->
<div *ngIf="isIos===true && isIosAlone===false">
  <div style="position: fixed; z-index: 20000; top: 0; left: 0; width: 100%; height: 100%; background-color: #000; opacity: 0.5"></div>
  <div style="position:fixed; z-index: 20001; width:100%; height:145px; bottom:0px;left:0">
    <div style="width: 90%; max-width: 700px; margin: 0 auto">
        <app-panel>
          <div panel-content style="font-size:24px;text-align:center;margin-top:0px;margin-bottom:5px">
          <div style="display: flex; justify-content: flex-end; margin-right: -5px; margin-top: -5px; padding-top:-15px">
            <button type="button" style="padding-top:-10px; font-size:20px" (click)="closeIosPopup()" class="scg-unstyled-button">X</button>
          </div>
          <div (click)="closeIosPopup()" style="margin-top:-10px;font-size:20px;text-align:center;font-weight:700;text-transform: uppercase">{{'IOS.INSTALL_HEADER'|translate}}</div>
          <div (click)="closeIosPopup()" style="height:10px"></div>
          <div style="font-size:14px">{{'IOS.INSTALL_1'|translate}}<img style="margin-left:10px;width:18px;height:18px" src="./assets/images/apple-share.png"></div>
          <div style="font-size:14px">{{'IOS.INSTALL_2'|translate}}
            <fa-icon [icon]="['fas', 'plus-square']"></fa-icon></div>
          </div>
        </app-panel>
    </div>
  </div>
</div>

